import React, { useEffect } from 'react';

function ParallaxSection({ children, className }) {
  useEffect(() => {
    const el = document.querySelector(`.${className}`);
    if (!el) return;
    const onScroll = () => {
      const scrolled = window.pageYOffset;
      const speed = 0.5;
      el.style.transform = `translateY(${scrolled * speed}px)`;
    };
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, [className]);
  return <section className={className}>{children}</section>;
}

export default ParallaxSection;
